/**
 * Scroll-linked word color reveal for the Grid Quote block.
 *
 * Every word starts in the muted quote color and lights up to full color
 * word-by-word, scrubbed to scroll position.
 *
 * Scoped to `.grid-quote__text`.
 */
export const gridQuoteReveal = () => {
  const els = document.querySelectorAll('.grid-quote__text');
  if (!els.length) return;

  const prefersReducedMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  const quotes = [];

  els.forEach((el) => {
    const target = el.querySelector('p') || el;
    const text = target.textContent.trim().replace(/\s+/g, ' ');
    if (!text) return;

    const words = text.split(' ');
    target.replaceChildren();

    const wordEls = words.map((word, i) => {
      const span = document.createElement('span');
      span.className = 'grid-quote__word';
      span.textContent = word;
      if (prefersReducedMotion) span.classList.add('is-active');
      target.appendChild(span);
      if (i < words.length - 1) {
        target.appendChild(document.createTextNode(' '));
      }
      return span;
    });

    quotes.push({ el, words: wordEls });
  });

  if (prefersReducedMotion) return;

  const update = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight;

    quotes.forEach(({ el, words }) => {
      const { top, height } = el.getBoundingClientRect();
      const center = top + height / 2;
      const startCenter = vh * 0.8;
      const endCenter = vh * 0.28;
      const progress = Math.min(
        Math.max((startCenter - center) / (startCenter - endCenter), 0),
        1
      );
      const activeCount = Math.round(progress * words.length);

      words.forEach((word, i) => {
        word.classList.toggle('is-active', i < activeCount);
      });
    });
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
};
